import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/site";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 5200);
    return () => window.clearInterval(timer);
  }, [paused]);

  const go = (dir: number) => {
    setActive((prev) => (prev + dir + heroSlides.length) % heroSlides.length);
  };

  const slide = heroSlides[active];

  return (
    <section
      className="relative h-[560px] w-full overflow-hidden md:h-[680px]"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {heroSlides.map((item, index) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === active ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={item.image}
            alt={`${item.title} 焦点图`}
            title={`天海翼 ${item.title}`}
            className="h-full w-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/40" />

      <div className="relative mx-auto flex h-full max-w-[1280px] flex-col justify-center px-4 md:px-6">
        <div className="max-w-2xl text-background-50">
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs tracking-wider">
            <i className="ri-film-line text-accent-400" />
            影视作品 · 明星资讯 · 人物资料
          </span>
          <h1 className="font-heading text-3xl font-bold leading-tight md:text-5xl">
            天海翼影视作品与明星资讯大全
          </h1>

          <div key={slide.id} className="mt-6 animate-fade-up">
            <div className="mb-2 inline-flex items-center gap-2">
              <span className="rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-foreground-950">
                {slide.tag}
              </span>
            </div>
            <h2 className="font-heading text-xl font-semibold md:text-2xl">{slide.title}</h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-100/85 md:text-base">
              {slide.subtitle}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to={slide.link}
                className="cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
              >
                查看详情
              </Link>
              <Link
                to="/works"
                className="cursor-pointer whitespace-nowrap rounded-md border border-background-50/40 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                浏览全部作品
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 items-center gap-2">
        {heroSlides.map((item, index) => (
          <button
            key={item.id}
            type="button"
            aria-label={`切换到第 ${index + 1} 张`}
            onClick={() => setActive(index)}
            className={`h-2 cursor-pointer rounded-full transition-all ${
              index === active ? "w-8 bg-accent-500" : "w-2 bg-background-50/50 hover:bg-background-50/80"
            }`}
          />
        ))}
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-background-50/30 bg-foreground-950/30 text-background-50 transition-colors hover:bg-foreground-950/60 md:left-5 md:flex"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-background-50/30 bg-foreground-950/30 text-background-50 transition-colors hover:bg-foreground-950/60 md:right-5 md:flex"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>
    </section>
  );
}